module.exports = __webpack_public_path__ + "static/img/img_tip2.2a53be23.png";